import { APIClient } from './APIClient'

export const fetchPolylines = (language) => {
    return APIClient.get(`/v1/${language}/geospatial/hwylines`)
}
